import { render, staticRenderFns } from "./Notification223Entry.vue?vue&type=template&id=549b2550"
import script from "./Notification223Entry.vue?vue&type=script&lang=js"
export * from "./Notification223Entry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports